// import "./../../App.css";
import "./Form.css";
import React, { useState, useRef } from "react";
import { X } from "lucide-react";
import ReCAPTCHA from "react-google-recaptcha";

export default function Form(props) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [description, setDescription] = useState("");
  const [errors, setErrors] = useState({}); // To store error messages
  const [captchaToken, setCaptchaToken] = useState(null);
  const [loading, setLoading] = useState(false);

  const captchaRef = useRef(null);

  const validateEmail = (email) => {
    // Simple email validation regex
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const validateForm = () => {
    const newErrors = {};
    if (!name.trim()) {
      newErrors.name = "Name is required";
    }
    if (!email.trim()) {
      newErrors.email = "Email is required";
    } else if (!validateEmail(email)) {
      newErrors.email = "Invalid email format";
    }
    if (description.trim().split(/\s+/).length > 150) {
      newErrors.description = "Description should not exceed 150 words.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    // e.preventDefault();

    if (!captchaToken) {
      // Add the shake class to the captcha container if not verified
      if (captchaRef.current) {
        captchaRef.current.classList.add("shake");
        setTimeout(() => {
          captchaRef.current.classList.remove("shake");
        }, 500);
      }
      return; // Do not submit if captcha is not verified
    }

    if (validateForm()) {
      try {
        setLoading(true); // Start loading
        const response = await fetch(
          "https://blackdoor-captcha-backend-1.onrender.com/api/submit",
          {
            method: "POST",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              name: name,
              email: email,
              description: description,
              captchaToken: captchaToken, // Send token to the backend
            }),
          }
        );

        const data = await response.json();
        if (data.success) {
          // alert("Form submitted successfully");
          props.type("success");
          props.isToast(true);
          props.isForm(false);
          setLoading(false); // Stop loading
          setName("");
          setEmail("");
          setDescription("");
          setErrors({});
        } else {
          // alert("Captcha validation failed, try again!");
          console.error("Error adding document: ");
          props.type("error");
          props.isToast(true);
        }
      } catch (error) {
        console.error("Error:", error);
        props.type("error");
        props.isToast(true);
      }
    }
  };

  const onChange = (token) => {
    setCaptchaToken(token); // Set the token
  };

  const onExpired = () => {
    setCaptchaToken(null); // Reset the token
  };

  console.log(errors);

  return (
    <>
      <div className="form-cont">
        <div className="form-cont-inner">
          <div className="form-cont-inner-inner">
            <div className="form-side-text">
              <p>Lets start building your platform</p>
            </div>

            <div className="form">
              <div className="form-inner">
                {/* <p className="form-title">Please fill it up</p> */}
                <div className="form-inner-div">
                  <span className="input-title">Name</span>
                  <input
                    type="text"
                    placeholder="Enter your name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  ></input>

                  {errors?.name && (
                    <p
                      style={{
                        color: "red",
                        height: "0px",
                        alignSelf: "flex-end",
                      }}
                    >
                      {errors.name}
                    </p>
                  )}
                </div>
                <div className="form-inner-div">
                  <span className="input-title">Email</span>
                  <input
                    type="text"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  ></input>
                  {errors?.email && (
                    <p
                      style={{
                        color: "red",
                        height: "0px",
                        alignSelf: "flex-end",
                      }}
                    >
                      {errors.email}
                    </p>
                  )}
                </div>
                <div className="form-inner-div">
                  <span className="input-title">Description</span>
                  <textarea
                    placeholder="What do you want?"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    required
                  ></textarea>
                  {errors?.description && (
                    <p
                      style={{
                        color: "red",
                        height: "0px",
                        alignSelf: "flex-end",
                      }}
                    >
                      {errors.description}
                    </p>
                  )}
                </div>
                <div ref={captchaRef}>
                  <ReCAPTCHA
                    sitekey="6LdhLUsqAAAAANrQStf74sQIkq6lL_WaE2TSMuiV"
                    onChange={onChange}
                    onExpired={onExpired}
                  />
                </div>

                {!loading ? (
                  <button
                    type="submit"
                    onClick={handleSubmit}
                    className="submit-btn"
                    // disabled={!verified}
                  >
                    Submit
                  </button>
                ) : (
                  <button type="submit" className="submit-btn" disabled={true}>
                    Submitting...
                  </button>
                )}
              </div>
            </div>
          </div>
          <X
            onClick={() => props.isForm(false)}
            size={40}
            color="black"
            className="cancel"
          />
        </div>
      </div>
    </>
  );
}
